import React from 'react';
import { SignalBadge } from '@/src/listings/components/_shared/SignalBadge';
import { UrgencySignals } from '@/src/listings/components/UrgencySignals/UrgencySignals';
import { ShareButton } from '@/src/listings/components/_shared/buttons/ShareButton/ShareButton';
import { LikeEventButton } from '@/src/listings/components/LikeEventButton/LikeEventbutton';
import { useBasicInfo } from '@/src/listings/components/_shared/contexts/BasicInfoContext';
import styles from './EventSignalsBar.module.scss';

export const EventSignalsBar: React.FC = () => {
  const basicInfo = useBasicInfo();
  const isShareable = basicInfo.isShareable ?? false;

  return (
    <div className={styles.container}>
      <div className={styles.innerWrapper}>
        <div className={styles.signals}>
          <SignalBadge />
          <UrgencySignals eventId={basicInfo.id} />
        </div>
        <div className={styles.actionButtons}>
          {isShareable && (
            <ShareButton
              eventId={basicInfo.id}
              eventName={basicInfo.name}
              eventUrl={basicInfo.url}
              isShareable={isShareable}
            />
          )}
          <LikeEventButton />
        </div>
      </div>
    </div>
  );
};
